
import BunnyPlayer from "@/components/BunnyPlayer";

interface Props {
  videoId: string;
  lessonId: string;
  title: string;
}
const LearnerVideoSection = ({ videoId, lessonId, title }: Props) => (
  <section>
    <BunnyPlayer videoId={videoId} lessonId={lessonId} title={title} />
  </section>
);
export default LearnerVideoSection;
